import BaseSlider from './BaseSlider';
import {DATA_ATTR, URL_PARAMS} from '../config/constants';

export default class SliderWithThumbs extends BaseSlider {
  constructor(sliderEl) {
    super();
    this.sliderEl = sliderEl;
    this.thumbsEl;
    this.thumbsSliderInstance;
  }

  init() {
    this.getThumbs();
    this.initThumbsSlider();

    const sliderInstance = this.getSplideInstance(this.sliderEl);

    sliderInstance.sync(this.thumbsSliderInstance).mount();
    super.init({ sliderInstance: this.thumbsSliderInstance, sliderEl: this.thumbsEl });

    this.setSlide(sliderInstance);
  }

  initThumbsSlider() {
    if (!this.thumbsEl) {
      throw new Error('Thumbs element was not found...');
    }

    const thumbsSliderInstance = this.getSplideInstance(this.thumbsEl).mount();

    this.thumbsSliderInstance = thumbsSliderInstance;
  }

  getThumbs() {
    const selector = this.sliderEl.dataset[DATA_ATTR.SLIDER.THUMBS];
    const element = document.querySelector(selector);

    this.thumbsEl = element;

    return element;
  }

  setSlide(slider) {
    const params = new URL(window.location);
    const sliderType = params.searchParams.get(URL_PARAMS.SLIDER_NAME);
    const slideNumber = params.searchParams.get(URL_PARAMS.SLIDER_SLIDE);
    if(sliderType && sliderType === this.sliderInstance.root.id.split('-')[0] && slideNumber) {
      slider.go( slideNumber -1 );
    }
  }
}
